import {
  createContext,
  useContext,
  useState,
  useMemo,
  useCallback,
  memo,
  ReactNode,
} from "react";

const ColorContext = createContext<any>(null);
export const useColorContext = () => useContext(ColorContext);

const ColorProvider = ({ children }: { children: ReactNode }) => {
  const [color, setColor] = useState("gray");

  const getColor = useCallback((value: any) => setColor(value), []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const contextValue = useMemo(() => ({ color, getColor }), [color]);

  return (
    <ColorContext.Provider value={contextValue}>
      {children}
    </ColorContext.Provider>
  );
};

export default memo(ColorProvider);
